import { render, staticRenderFns } from "./contractManager.vue?vue&type=template&id=2c68dc8f&scoped=true"
import script from "./contractManager.vue?vue&type=script&lang=js"
export * from "./contractManager.vue?vue&type=script&lang=js"
import style0 from "./contractManager.vue?vue&type=style&index=0&id=2c68dc8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68dc8f",
  null
  
)

export default component.exports